import { render, staticRenderFns } from "./DaStudent.vue?vue&type=template&id=d9e79aec&"
import script from "./DaStudent.vue?vue&type=script&lang=js&"
export * from "./DaStudent.vue?vue&type=script&lang=js&"
import style0 from "./DaStudent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports